var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":"Business Type","outlined":"","dense":"","items":_vm.items,"value":_vm.value},on:{"input":function (newVal) { return _vm.$emit('input', newVal); }}})}
var staticRenderFns = []

export { render, staticRenderFns }